import * as React from 'react';
import CreateReportsCore from '../components/AfrCore/CreateReportsCore'
import { LogicalPeriodEnum, TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';


const CreateCourtReports29 = () => {
    return (
        <React.Fragment>
            <CreateReportsCore taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_29} reportName="Court Report 29.0085, F.S."
                logicalPeriods={[]} />
        </React.Fragment>
    );
}
export default CreateCourtReports29;
